import type { Dispatch } from "redux";
import { getUserId } from "../../comman/function";
import { authHeader } from "../../comman/mainfunction";
import { GET_NOTIFICATION_URL } from "../../comman/url";
import API from "../../constants/API";
import { NOTIFY_COUNT } from "./ActionType";
import type { AppAction } from "./ActionType";

export function getNotificationDetails() {
  return (dispatch: Dispatch<AppAction>): void => {
    const config = {
      method: "GET",
      url: GET_NOTIFICATION_URL,

      headers: authHeader() as unknown as Record<string, string>,
      params: {
        userId: getUserId(),
      },
    };
    API(config)
      .then((response) => {
        const { status, messageCount } = response.data as {
          status: string;
          messageCount: Array<{ totalCount: number }>;
        };

        if (status === "Success") {
          dispatch({
            type: NOTIFY_COUNT,
            payload: messageCount[0].totalCount,
          });
        }
      })

      .catch(() => {});
  };
}
